import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 15"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M16.16 1.982a1.106 1.106 0 0 1 1.545.242L21.29 7.14c.43.59.433 1.392.008 1.986l-3.586 5.01a1.106 1.106 0 1 1-1.799-1.287l2.546-3.559H1.105a1.106 1.106 0 0 1 0-2.213h17.4l-2.587-3.552a1.106 1.106 0 0 1 .242-1.544"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }